var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "c-form__section" },
    [
      _c("header", { staticClass: "c-form__section-header" }, [
        _vm.title
          ? _c("h2", { staticClass: "c-form__section-title" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.desc
          ? _c("div", {
              staticClass: "c-form__section-description",
              domProps: { innerHTML: _vm._s(_vm.desc) }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-acda610c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-acda610c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_contact-us-rap/_vue/FormSection.vue
// module id = 739
// module chunks = 0